import React from 'react';

import { ItemDetails } from './itemDropdownDetails';
import { SoldOutFacilitiesWarning, SoldOutIndicator } from './soldOutIndicator';

function CreateListItemDetails({ item }) {
    const soldOutFacilities = item?.soldOutFacilities ?? [];

    if (!soldOutFacilities.length) {
        return <ItemDetails item={item} />;
    }

    return (
        <ItemDetails
            item={item}
            afterName={<SoldOutIndicator />}
            headerContent={<SoldOutFacilitiesWarning facilityNames={soldOutFacilities} />}
        />
    );
}

export { CreateListItemDetails };
